const searchButton = document.querySelector('.search-list .search-again button');
if (searchButton) {
  searchButton.addEventListener('click', (event) => {
    event.preventDefault();
    document.querySelector('body').classList.toggle('is-open-search');
  });
}
